export enum EventDebugMessages {
  Error = 'ERROR: Sending event to Segment',
}
